import type { Connector } from './types/types';

const STORAGE_KEY = 'boomi-automate-connectors';
const STORAGE_HASH_KEY = 'boomi-automate-connectors-hash';

export const getConnectorsHash = () => localStorage.getItem(STORAGE_HASH_KEY);
export const setConnectorsHash = (hash: string | null) =>
    hash !== null
        ? localStorage.setItem(STORAGE_HASH_KEY, hash)
        : localStorage.removeItem(STORAGE_HASH_KEY);

export const getConnectors = () => {
    const source = localStorage.getItem(STORAGE_KEY);

    if (source) {
        return JSON.parse(source);
    }

    return {};
};

export const setConnectors = (connectors: Record<string, Connector>) =>
    localStorage.setItem(STORAGE_KEY, JSON.stringify(connectors));
